import http from 'hub-http/clients/apiClient';
export const DEFAULT_COLUMNS_URL = '/forecasting/v1/settings/portal-default-deal-column';
export const DEFAULT_COLUMNS_FIELD_NAME = 'defaultColumns';
export const updateDefaultColumns = ({
  columns,
  forecastTypeId
}) => {
  return http.put(`${DEFAULT_COLUMNS_URL}`, {
    data: {
      forecastTypeId,
      dealColumns: columns
    }
  });
  // Consumer to catch errors
};